<template>
  <div class="mobile-container">
    <!-- 顶部导航 -->
    <div class="page-header">
      <div class="page-header-content">
        <img  src='@/assets/head1.png'>
      </div>
    </div>

    <!-- 主内容区 -->
    <main class="mobile-content">
      <!-- 欢迎图片 -->
      <section class="welcome-image">
        <img  src='@/assets/zhibao.png'>
      </section>

      <!-- 关于我们 -->
      <section id="about" class="mobile-section">
        <div class="section-title-container">
          <div class="section-title-block"></div>
          <h2 class="section-title">关于我们</h2>
          <h2 class="section-title-en">About Us</h2>
        </div>
        <div class="about-content">
          <div class="about-text">
            <p>领班人广告连锁专注于线下广告实体服务，是国内领先的广告制作连锁品牌。</p>
            <p>我们依托遍布全国的实体门店网络，为中小企业和商户提供便捷、专业的“一站式”广告解决方案——涵盖设计、制作、安装及维护。</p>
            <p>连锁标准，品质如一！</p>
          </div>
        </div>
      </section>

      <!-- 联系我们 -->
      <section id="contact" class="mobile-section">
        <div class="section-title-container-contact ">
          <div class="section-title-container-contact-title">
              <div class="section-title-block"></div>
              <h2 class="section-title">客服热线</h2>
          </div>  
          
          <div class="tags-container">
            <el-tag type="sucess">广告业务</el-tag>
            <el-tag type="sucess">加盟业务</el-tag>
          </div>
        </div>
        <div class="contact-info">
          <div class="info-item">
            <img src="@/assets/phonenum.png">
          </div>
        </div>
        <button class="contact-btn" @click="makeCall">
          <span>一键拨打电话</span>
        </button>
      </section>

      <!-- 服务项目 -->
      <section id="services" class="mobile-section">
        <div class="section-title-container">
          <div class="section-title-block"></div>
          <h2 class="section-title">服务项目</h2>
          <h2 class="section-title-en">Service Items</h2>
        </div>
        <div class="services-list">
          <div class="service-card">
            <div class="card-icon">
              <img src="@/assets/card-icon1.png">
            </div>
            <div class="card-content">
              <h3>广告制作</h3>
              <p>门头店招、党建文化、商业会展、标化工地广告定制专家。</p>
            </div>
          </div>
          <div class="service-card">
            <div class="card-icon">
              <img src="@/assets/card-icon2.png">
            </div>
            <div class="card-content">
              <h3>门市工装</h3>
              <p>商业空间设计装修；门面装饰、照明工程、专柜展具定制。</p>
            </div>
          </div>
          <div class="service-card">
            <div class="card-icon">
              <img src="@/assets/card-icon3.png">
            </div>
            <div class="card-content">
              <h3>亮化工程</h3>
              <p>楼体灯光艺术塑造；商业空间光效定制，提升品牌形象与价值。</p>
            </div>
          </div>
          <div class="service-card">
            <div class="card-icon">
              <img src="@/assets/card-icon4.png">
            </div>
            <div class="card-content">
              <h3>钢结构工程</h3>
              <p>钢结构设计生产安装；建筑围挡施工工程服务。</p>
            </div>
          </div>
          <div class="service-card">
            <div class="card-icon">
              <img src="@/assets/card-icon5.png">
            </div>
            <div class="card-content">
              <h3>标识标牌</h3>
              <p>楼顶大字、精神堡垒、立体标识设计制作，品牌空间形象塑造者。</p>
            </div>
          </div>
        </div>
      </section>

    </main>

    <!-- 返回顶部按钮 -->
    <div class="back-top" @click="scrollToTop" v-show="showBackTop">
      ↑
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHomePage',
  data() {
    return {
      showMenu: false,
      showBackTop: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      this.showMenu = false;
    },
    scrollTo(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.showBackTop = window.scrollY > 300;
    },
    makeCall() {
      window.location.href = 'tel:400-6920-220';
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  background-color: #f5f5f5;
}

.mobile-container {
  padding: 0px;
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

/* 页面标题 */
.page-header {
  margin-bottom: 10px;
  text-align: center;
  background-color: rgb(238, 238, 238);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.page-header-content{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-header-content img{
  width: 100%;
  height: auto;
  object-fit: contain;
}

.headertitle {
  font-size: 30px;
  font-weight: bold;
  color: #012db2;
  margin: 0;
  padding: 0;
}

/* 欢迎图片 */
.welcome-image {
  width: 100%;
  height: auto;
  background: #fcfcfc;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
}

.welcome-image img {
  width: 90%;
  height: auto;
  object-fit: contain;
}

/* 主内容区 */
.mobile-content {
  margin-top: 10px;
  padding: 5px;
  padding-bottom: 15px;
}

/* 通用区块样式 */
.mobile-section {
  background-color: white;
  margin-bottom: 10px;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.section-title-block{
  width: 10px;
  height: 25px;
  background-color: #ffec01;
}

.section-title {
  font-size: 18px;
  color: #000000;
  margin-bottom: 0px;
  padding-bottom: 5px;
  font-weight: bold;
}

.section-title-en{
  font-size: 14px;
  color: #000000;
  font-weight: 200;
}

/* 关于我们 */
.about-content {
  display: flex;
  flex-direction: column;
}

.about-text {
  margin-top: 10px;
}

.about-text p {
  margin-bottom: 10px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 服务项目 - 卡片样式 */
.services-list {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.service-card {
  background: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.service-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.card-icon {
  width: 40px;
  height: 40px;
  background-color: #ffec01;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.card-icon img  {
  width: 25px;
  height: 25px;
  color: #012db2;
}

.card-content h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.card-content p {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}



/* 标题和标签容器 */
.section-title-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  gap: 10px;
}

.section-title-container-contact-title{
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title-container-contact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

/* 标签容器 */
.tags-container {
  display: flex;
  gap: 4px;
}

/* 调整标签样式 */
.el-tag {
  margin: 0;
  padding: 6px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  background-color: #a5cbf5;
  color: #007dff;
}

/* 调整标题样式 */
.section-title-contact {
  font-size: 18px;
  color: #000000;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  font-weight: bold;

  margin: 0;
  padding: 0;
  border: none;
}


.contact-info {
  margin-top: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  justify-content: center;
}

.info-item img {
  width: 80%;
  height: auto;
  object-fit: contain;
}

.contact-btn {
  width: 100%;
  padding: 12px;
  background-color: #ffec01;
  color: #012db2;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.contact-btn:hover {
  background-color: #9b9105;
}

/* 返回顶部按钮 */
.back-top {
  position: fixed;
  right: 15px;
  bottom: 70px;
  width: 40px;
  height: 40px;
  background-color: #524c04;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 100;
  transition: transform 0.3s ease;
}

.back-top:hover {
  transform: scale(1.1);
}

/* 响应式调整 */
@media (min-width: 414px) {
  .section-title {
    font-size: 20px;
  }
  
}


</style>